export interface Announcement {
  id: number;
  subject: string;
  from_email: string;
  created_on_utc: string;
  message: string;
  created_by_user: number;
  recipients: AnnouncementRecipients;
  email: boolean;
  notification: boolean;
}

export interface OriginalRecipients {
  connections: string[];
  users: string[];
}

export class AnnouncementRecipients {
  public readonly original_recipients!: OriginalRecipients;
  public readonly derived_recipients!: DerivedRecipient[];
}

export class DerivedRecipient {
  public readonly user_id!: number;
  public readonly email!: string;
}

export interface NewAnnouncement {
  to: string;
  subject: string;
  message: string;
}

export interface AnnouncementCreateRequest {
  subject: string;
  message: string;
  recipients: OriginalRecipients;
  email: boolean;
  notification: boolean;
}

export enum AnnouncementType {
  EMAIL = 0,
  NOTIFICATION = 1,
}
